module.exports = __webpack_public_path__ + "img/d64aa.364455fb.svg";